import styled from '@emotion/styled';

export const StyledListItem = styled.li`
  display: flex;
  gap: 5px;
  padding: 10px;
  border-left-width: 5px;
  border-left-color: ${(props) => (props.active ? '#a3a0fb' : '#43425d')};
  border-left-style: solid;
  align-items: center;
  ${(props) => (props.active ? 'background-color: #3c3b54;' : '')}
  :hover {
    background-color: #3c3b54;
  }
`;
